import React, { FC } from "react";
import type { PayallStoryGalleryProps } from "@/types";
import "swiper/swiper.min.css";
import { Navigation, A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { Image } from "../image";
import { SwiperNavigation } from "../swiper";

export const PayallStoryGallery: FC<PayallStoryGalleryProps> = ({
  gallery,
}) => {
  return (
    <section className="payallStoryGallery">
      <div className="wrapper wrapper_lg">
        <Swiper
          modules={[A11y, Navigation]}
          navigation={{
            prevEl: ".payallStoryGallery--navigation button:first-of-type",
            nextEl: ".payallStoryGallery--navigation button:last-of-type",
          }}
          spaceBetween={12}
          slidesPerView={1.25}
          breakpoints={{
            1024: {
              slidesPerView: "auto",
              spaceBetween: 32,
            },
          }}
          grabCursor
          className="payallStoryGallery--swiper"
        >
          <SwiperNavigation className="payallStoryGallery--navigation" />
          {gallery.map((slide, index) => {
            return (
              <SwiperSlide key={index} className="payallStoryGallery--slide">
                {slide.file?.url && (
                  <Image
                    className="payallStoryGallery--slide-image"
                    src={slide as any}
                    alt={slide.title}
                    draggable={false}
                    animateInView
                    options={{
                      sizes: {
                        exec: [
                          {
                            width: 870,
                            height: 663,
                          },
                        ],
                      },
                    }}
                  />
                )}
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </section>
  );
};
